import React, { useState } from "react";
import { MdOutlineArrowRightAlt } from "react-icons/md";
import { LiaPhoneVolumeSolid } from "react-icons/lia";
import { NavLink } from "react-router-dom";
import linkedin from "../../assets/linkedin.png";
import insta from "../../assets/insta.png";
import fb from "../../assets/fb.png";
import { Newsletter } from "../../api/endpoints";
import Api_Instance from "../../api/Api_Instance";
import toast from "react-hot-toast";
import { IoMdMail } from "react-icons/io";
import Loader from "../../common/loader/Loader";

function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const api = Api_Instance.unAuth();
  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      if (email.length > 0) {
        const response = await api("POST", Newsletter?.POST_NEWSLETTER_API, {
          email: email,
        });
        toast.success(response?.data?.message);
      }
      setEmail("");
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div className="bg-[#f0f0f0] h-auto xl:p-5 lg:p-5 md:p-5 p-3 relative mt-28">
        <div className="absolute -top-20 left-1/2 transform -translate-x-1/2 rounded-sm bg-secondaryColor w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4 h-32 flex items-center justify-center p-[67px]">
          <div className="flex flex-col lg:flex-row items-center 2xl:justify-between xl:justify-between lg:justify-center w-full gap-4 md:gap-20">
            <h3 className="2xl:text-2xl xl:text-2xl lg:text-text-lg	text-lg text-white font-md mb-2 md:mb-0 text-center md:text-left">
              Newsletter Signup
            </h3>
            <div>
              <form
                onSubmit={handleSubmit}
                className="flex items-center w-full md:w-auto"
              >
                <input
                  className="border rounded-l-md p-2 flex-grow w-full 2xl:max-w-[550px] xl:max-w-[550px] lg:max-w-[550px] md:max-w-[550px] max-w-[200px] 2xl:min-w-[550px] xl:min-w-[550px] lg:min-w-[550px] md:min-w-[550px] min-w-[200px]"
                  type="email"
                  placeholder="Enter your email"
                  required
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-secondaryColor border border-[#ffffff] text-white p-2 flex justify-center items-center  align-center rounded-r-md gap-x-0.5 w-full max-w-[135px] min-w-[135px]"
                >

                  {loading ? (
                    <Loader />
                  ) : (
                    <>
                      <span>Explore</span>
                      <MdOutlineArrowRightAlt className="mt-1" />
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4">
          <div className="grid xl:md:grid-cols-3 lg:md:grid-cols-3 grid-cols-2 md:grid-cols-3 gap-8 mt-[100px] mb-[50px]">
            <div>
              <h3 className="text-[18px] font-medium mb-3">
                Browse By Investment Range
              </h3>
              <div className="flex flex-col sm:flex-row gap-8">
                <ul>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Under 1 Lakh</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Under 2 Lakh</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Under 3 Lakh</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Under 4 Lakh</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Under 5 Lakh</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Under 10 Lakh</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Under 20 Lakh</li>
                </ul>
                <ul>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Under 30 Lakh</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Under 40 Lakh</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Under 50 Lakh</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Under 1 Cr</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Under 2 Cr</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Under 5 Cr</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Above 10 Cr</li>
                </ul>
              </div>
            </div>
            <div>
              <h3 className="text-[18px] font-medium mb-3">Browse By Location</h3>
              <div className="flex flex-col sm:flex-row gap-8">
                <ul className="cursor-pointer">
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Maharashtra</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Delhi</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Karnataka</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Tamil Nadu</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">West Bengal</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Gujarat</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Uttar Pradesh</li>
                </ul>
                <ul className="cursor-pointer">
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Madhya Pradesh</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Haryana</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Rajasthan</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Andhra Pradesh</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Kerala</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Punjab</li>
                  <li className="text-[#000000] mb-[10px] cursor-pointer text-sm">Chandigarh</li>
                </ul>
              </div>
            </div>
            <div>
              <h3 className="text-[18px] font-medium mb-2" >Contact Info</h3>
              <div className="flex flex-col gap-8">
                <ul className="space-y-4">
                  <li className="flex items-start gap-2 cursor-pointer">
                    <a href={`tel:${'sales@frachisebx.com'}`}>
                      <IoMdMail className="2xl:text-2xl xl:text-2xl lg:text-2xl md:text-2xl text-3xl" />
                    </a>
                    <div>
                      <p className="text-[#000000] font-md text-xl" >Email</p>
                      <p className="text-[#000000]  text-sm">
                        sales@frachisebx.com
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start gap-2">
                    <a href={`tel:${9530002568}`}>
                      <LiaPhoneVolumeSolid className="2xl:text-2xl xl:text-2xl lg:text-2xl md:text-2xl text-3xl" />
                    </a>
                    <div className="cursor-pointer">
                      <p className="text-[#000000] font-md text-xl">Phone</p>
                      <p className="text-[#000000] text-sm">+91 9530002568</p>
                    </div>


                  </li>
                  <li className="flex items-center gap-4 mt-4">
                    <a
                      href="https://www.linkedin.com/company/franchisebx/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-[30px]"
                    >
                      <img src={linkedin} alt="LinkedIn" className="w-[30px]" />
                    </a>
                    <a
                      href="https://www.instagram.com/franchise_bx"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-[30px]"
                    >
                      <img src={insta} alt="Instagram" className="w-[30px]" />
                    </a>
                    <a
                      href="https://www.facebook.com/franchisebx/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-[30px]"
                    >
                      <img src={fb} alt="Facebook" className="w-[30px]" />
                    </a>
                    {/* <a
                      href="https://www.youtube.com/yourchannel" 
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-[30px]"
                    >
                      <img src={youtube} alt="YouTube" className="w-[30px]" />
                    </a> */}
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#13A9D3]">
        <div className="w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4 flex flex-col sm:flex-row justify-between items-center p-2">
          <div className="flex items-center">
            <p className="text-[#D0DEE8] text-sm  mt-2 ">
              Copyright © 2024 Franchise BX
            </p>
          </div>
          <ul className="flex flex-wrap gap-[10px]  sm:mt-0 sm:gap-[33px] mt-2 items-center justify-center sm:justify-start">
            <li>
              <NavLink to="/" className="text-[#D0DEE8] text-sm">
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/about" className="text-[#D0DEE8] text-sm">
                About
              </NavLink>
            </li>
            {/* <li>
            <NavLink to="/career" className="text-[#D0DEE8] text-sm">
              Career
            </NavLink>
          </li> */}
            <li>
              <NavLink to="/contact" className="text-[#D0DEE8] text-sm">
                Contact
              </NavLink>
            </li>
            <li>
              <NavLink to="/blogs" className="text-[#D0DEE8] text-sm">
                Blogs
              </NavLink>
            </li>
            <li>
              <NavLink to="/video" className="text-[#D0DEE8] text-sm">
                Video
              </NavLink>
            </li>
            {/* <li>
            <NavLink to="/events" className="text-[#D0DEE8] text-sm">
              Events
            </NavLink>
          </li> */}
            <li>
              <NavLink to="/terms" className="text-[#D0DEE8] text-sm">
                Terms & Condition
              </NavLink>
            </li>
            <li>
              <NavLink to="/faq" className="text-[#D0DEE8] text-sm">
                FAQ
              </NavLink>
            </li>
            {/* <li>
              <NavLink to="/testimonial" className="text-[#D0DEE8] text-sm">
                Testimonial
              </NavLink>
            </li> */}
          </ul>
        </div>
      </div>
    </>
  );
}

export default Footer;
